<template>
  <div>
    <div :class="['section-title', { active: isActive }]">
      <h3>Tanggal Efektif</h3>
    </div>
    <div v-if="isActive" class="effective-date-section">
      <!-- Main Date Field -->
      <div class="date-field-wrapper">
        <label
          class="field-label"
          :class="[{ disabled: getFormData.clientRequestMidMonth }]"
        >
          Menargetkan Perubahan Nama & Pengalihan Unit Pada Akhir Bulan
        </label>
        <InputDate
          id="effective-date"
          :disabled="disabledInput || getFormData.clientRequestMidMonth"
          type="month"
          :value="getFormData.effectiveMonth"
          placeholder="Pilih Bulan"
          @change="setEffectiveMonth($event)"
        />
      </div>

      <div class="mt-2">
        <ToggleSwitch
          :value="getFormData.clientRequestMidMonth"
          label="Klien meminta tanggal perubahan di pertengahan bulan"
          @change="setClientRequestMidMonth(!getFormData.clientRequestMidMonth)"
          :disabled="disabledInput"
        />
      </div>

      <div v-if="getFormData.clientRequestMidMonth" class="mt-2">
        <div class="date-field-wrapper">
          <label class="field-label">
            Menargetkan perubahan nama & pengalihan unit pada pertengahan bulan
          </label>
          <InputDate
            id="effective-date"
            :disabled="disabledNotDraft"
            :value="getFormData.midMonthEffectiveDate"
            placeholder="Pilih Tanggal"
            @change="setMidMonthEffectiveDate($event)"
          />
        </div>
        <div
          v-if="!isNaN(midMonthEffectiveLastDateOfMonth)"
          class="mid-month-note mt-1"
        >
          <p>
            Lessee Awal ditagih: (harga ÷
            {{ midMonthEffectiveLastDateOfMonth }}) ×
            {{ initialLesseeBilledDays }} hari
          </p>
          <p>
            Lessee Target ditagih: (harga ÷
            {{ midMonthEffectiveLastDateOfMonth }}) ×
            {{ targetLesseeBilledDays }} hari
          </p>
        </div>
      </div>

      <div
        class="header-close mb-2"
        :class="[{ 'yellow-highlight': getFormData.clientRequestMidMonth }]"
        v-if="
          !showInfoPanel &&
          (getFormData.effectiveMonth || getFormData.midMonthEffectiveDate)
        "
      >
        <p class="label">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle
              cx="8"
              cy="8"
              r="7"
              :stroke="
                getFormData.clientRequestMidMonth ? '#973C00' : '#22511e'
              "
              stroke-width="1.5"
            />
            <text
              x="8"
              y="11"
              text-anchor="middle"
              font-size="10"
              :fill="getFormData.clientRequestMidMonth ? '#973C00' : '#22511e'"
            >
              !
            </text>
          </svg>
          {{ headerNoteText }}
          <u style="cursor: pointer" @click="showInfoPanel = true"
            >Info lengkap klik disini</u
          >
        </p>
      </div>

      <!-- Info Panel -->
      <div v-if="showInfoPanel">
        <div v-if="getFormData.clientRequestMidMonth" class="header-open">
          <p class="title">Perbandingan dua metode Perubahan</p>
          <span class="close-btn ml-4" @click="showInfoPanel = false">
            Tutup info klik disini ✕
          </span>
        </div>
        <div class="d-flex" style="gap: 8px">
          <div class="info-panel">
            <!-- Header -->
            <div class="info-panel-header">
              <div class="header-left mb-2">
                <span class="normal">Normal</span>
                <span
                  v-if="!getFormData.clientRequestMidMonth"
                  class="close-btn ml-4"
                  @click="showInfoPanel = false"
                >
                  Tutup info klik disini ✕
                </span>
              </div>
              <div class="info-title">
                <span class="title-main">Perubahan akhir bulan</span>
                <span class="title-subtitle">~90% dari kasus</span>
              </div>
            </div>

            <!-- Content -->
            <div class="info-panel-content">
              <!-- Info Items -->
              <div class="info-items">
                <div class="info-item p-0">
                  <span class="info-label">Tanggal Perubahan</span>
                  <div class="info-value-wrapper">
                    <span class="info-value">
                      Hari terakhir bulan target<br />
                      <p style="width: fit-content">
                        akhir_bulan (bulan_target)
                      </p>
                      <br />
                    </span>
                  </div>
                </div>

                <div class="info-item">
                  <span class="info-label">Lessee Awal Ditagih</span>
                  <span class="info-value">
                    Bulan penuh saat ini - tidak ada perubahan pada invoice yang
                    ada
                  </span>
                </div>

                <div class="info-item">
                  <span class="info-label">Lessee Target Ditagih</span>
                  <span class="info-value">
                    Dari tanggal 1 bulan depan - bulan penuh, siklus bersih
                  </span>
                </div>

                <div class="info-item">
                  <span class="info-label">Prorate</span>
                  <span class="info-value">Tidak diperlukan</span>
                </div>

                <div class="info-item">
                  <span class="info-label">Perkerjaan Keuangan</span>
                  <span class="info-value">
                    Verifikasi syarat pesanan baru saja - tidak ada split
                    invoice
                  </span>
                </div>
              </div>

              <!-- Info Box -->
              <div class="info-box">
                <p>
                  Metode sederhana. Tidak ada kompleksitas penagihan. Lessee
                  awal membayar bulan ini secara penuh - tidak ada risiko kredit
                  untuk Asani.
                </p>
              </div>
            </div>
          </div>
          <div v-if="getFormData.clientRequestMidMonth" class="info-panel">
            <!-- Header -->
            <div class="info-panel-header yellow-highlight">
              <div class="header-left mb-2">
                <span class="normal label">Pengecualian</span>
              </div>
              <div class="info-title">
                <span class="title-main label"
                  >Perubahan pertengahan bulan</span
                >
                <span class="title-subtitle"
                  >Hanya berdasarkan permintaan klien</span
                >
              </div>
            </div>

            <!-- Content -->
            <div class="info-panel-content">
              <!-- Info Items -->
              <div class="info-items">
                <div class="info-item pt-0">
                  <span class="info-label">Tanggal Perubahan</span>
                  <div class="info-value-wrapper">
                    <span class="info-value">
                      Tanggal spesifik yang dipilih oleh klien - harus
                      dikonfirmasi secara tertulis
                      <br />
                    </span>
                  </div>
                </div>

                <div class="info-item">
                  <span class="info-label">Tanggal Perubahan</span>
                  <div class="info-value-wrapper">
                    <span class="info-value">
                      <p style="width: fit-content">
                        (harga ÷ hari_dalam_bulan) × hari_hingga_T
                      </p>
                      <br />
                    </span>
                  </div>
                </div>

                <div class="info-item p-0">
                  <span class="info-label">Lessee Target ditagih</span>
                  <div class="info-value-wrapper">
                    <span class="info-value">
                      <p style="width: fit-content">
                        (harga ÷ hari_dalam_bulan) × hari_hingga_T+1
                      </p>
                      <br />
                    </span>
                  </div>
                </div>

                <div class="info-item">
                  <span class="info-label">Prorate</span>
                  <span class="info-value">
                    Pembagian float, hari kalender aktual. Perhitungan sistem,
                    konfirmasi CSS.
                  </span>
                </div>

                <div class="info-item">
                  <span class="info-label">Perkerjaan Keuangan</span>
                  <span class="info-value">
                    Verifikasi keduanya dari nilai invoice yang diprorate +
                    syarat pesanan baru
                  </span>
                </div>
              </div>

              <!-- Info Box -->
              <div class="info-box yellow-highlight">
                <p class="label">
                  Pekerjaan verifikasi Finance lebih lanjut. Memerlukan
                  persetujuan eksplisit dari klien terkait split penagihan
                  sebelum CSS dapat mengajukan.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="getFormData.clientRequestMidMonth" class="date-field-wrapper">
        <label class="field-label"> Persetujuan Klien </label>
        <div
          class="checkbox-form"
          :class="[{ 'checkbox-active': getFormData.termChecked }]"
        >
          <input
            type="checkbox"
            :checked="getFormData.termChecked"
            id="client-agreement"
            @change="setTermChecked(!getFormData.termChecked)"
            :disabled="disabledInput"
          />
          <label for="client-agreement"
            >Klien mengonfirmasi penagihan split pertengahan bulan berdasarkan
            {{ parseMidMonthEffectiveDate }}</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { InputDate, ToggleSwitch } from "@/components/Input";
import { mapGetters, mapMutations } from "vuex";
import mixin from "@/components/RentAdjustment/mixin";

export default {
  name: "EffectiveDate",
  components: {
    InputDate,
    ToggleSwitch,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showInfoPanel: false,
    };
  },
  mixins: [mixin],
  computed: {
    ...mapGetters("rentAdjustment", {
      currentStep: "getCurrentStep",
      getFormData: "getFormData",
      transferUnitStatus: "getStatus",
      disabledNotDraft: "getDisabledNotDraft",
    }),
    clientRequestMidMonth() {
      return this.$store.state.rentAdjustment.clientRequestMidMonth;
    },
    parseEffectiveDateNote() {
      const monthsID = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];

      const splitDate = this.getFormData.effectiveMonth.split("-");
      const monthName = monthsID[splitDate[1] - 1];
      const year = splitDate[0];

      // get last date of month
      const lastDateOfMonth = new Date(splitDate[0], splitDate[1], 0).getDate();

      return `${lastDateOfMonth} ${monthName} ${year}`;
    },
    parseMidMonthEffectiveDate() {
      return new Date(
        this.getFormData.midMonthEffectiveDate
      ).toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    headerNoteText() {
      if (this.getFormData.clientRequestMidMonth) {
        return "Perubahan pertengahan bulan - prorate akan diterapkan. Klien telah diberitahu dan menyetujui.";
      } else {
        return `Tanggal pengalihan unit/perubahan akan diatur tanggal
          ${this.parseEffectiveDateNote}
          (Tanggal terakhir penagihan). Tidak ada prorate invoice.`;
      }
    },
    initialLesseeBilledDays() {
      const date = new Date(this.getFormData.midMonthEffectiveDate);
      if (date.toString() === "Invalid Date") return 0;
      return date.getDate() - 1;
    },
    targetLesseeBilledDays() {
      const splitDate = this.splitMidMonthEffectiveDate;
      return this.midMonthEffectiveLastDateOfMonth - (Number(splitDate[2]) - 1);
    },
    midMonthEffectiveLastDateOfMonth() {
      const splitDate = this.splitMidMonthEffectiveDate;
      return new Date(splitDate[0], splitDate[1], 0).getDate();
    },
    splitMidMonthEffectiveDate() {
      const midMonthEffectiveDate = this.getFormData.midMonthEffectiveDate;
      return midMonthEffectiveDate.split("-");
    },
  },
  methods: {
    ...mapMutations("rentAdjustment", {
      setEffectiveMonth: "SET_EFFECTIVE_MONTH",
      setTermChecked: "SET_TERM_CHECKED",
      setClientRequestMidMonth: "SET_CLIENT_REQUEST_MID_MONTH",
      setMidMonthEffectiveDate: "SET_MID_MONTH_EFFECTIVE_DATE",
    }),
    parseDate(value) {
      const monthsID = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];

      const splitDate = value.split("-");
      const monthName = monthsID[splitDate[1] - 1];
      const year = splitDate[0];

      // get last date of month
      const lastDateOfMonth = new Date(splitDate[0], splitDate[1], 0).getDate();

      return `${lastDateOfMonth} ${monthName} ${year}`;
    },
    handlePrevious() {
      this.$emit("prev");
    },
    handleNext() {
      this.$emit("next");
    },
  },
};
</script>

<style scoped>
.section-title {
  flex: 1;
}

.section-title h3 {
  font-size: 16px;
  font-weight: 600;
  color: #2e3646;
  opacity: 0.4;
  text-transform: capitalize;
  margin-bottom: 12px;
}

.section-title.active h3 {
  opacity: 1;
}

.effective-date-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2e3646;
  margin: 0;
  margin-bottom: 12px;
}

.date-field-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 14px;
  font-weight: 500;
  color: #2e3646;
  margin: 0;
}

.field-label.disabled {
  color: #979ba3;
}

/* Info Panel */
.info-panel {
  border: 1px solid #d1d9e2;
  border-radius: 8px;
  overflow: hidden;
  background-color: #ffffff;
}

.info-panel-header {
  background-color: #e8f5e9;
  padding: 12px 16px;
  border-bottom: 1px solid #d1d9e2;
}

.header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.header-close {
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #e8f5e9;
  padding: 12px 16px;
  border: 1px solid #d1d9e2;
  border-radius: 8px;
}

.header-close .label {
  font-size: 12px;
  font-weight: 500;
  color: #22511e;
  margin: 0;
}

.status-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 4px;
  display: inline-block;
}

.normal {
  color: #22511e;
  font-size: 14px;
  font-weight: 600;
}

.close-btn {
  font-size: 12px;
  color: #2e3646;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;
}

.info-panel-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-title {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.title-main {
  font-size: 16px;
  font-weight: 600;
  color: #2e3646;
}

.title-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.info-items {
  display: flex;
  flex-direction: column;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #2e3646;
  display: block;
}

.info-value-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  position: relative;
}

.info-value {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
}

.info-value p {
  padding: 2px 8px;
  background: #eceff2;
  border-radius: 8px;
  margin: 0;
  margin-top: 8px;
}

.info-value code {
  font-family: "Courier New", monospace;
  background-color: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  display: inline-block;
  margin-top: 4px;
  color: #2e3646;
}

.red-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #dc3545;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 2px;
}

.info-box {
  background-color: #e8f5e9;
  border: 1px solid #9ce293;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 12px;
}

.info-box p {
  font-size: 13px;
  color: #2e7d32;
  line-height: 1.5;
  margin: 0;
}

.yellow-highlight .label {
  color: #973c00;
}

.yellow-highlight {
  border: 1px solid #fee685;
  background-color: #fffbeb;
}

/* Toggle Section */
.toggle-section {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
}

.toggle-label {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #2e3646;
  cursor: pointer;
  user-select: none;
}

.toggle-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #247fec;
}

.button-group {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.btn {
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #247fec;
  color: #ffffff;
}

.btn-primary:hover {
  background-color: #1a5cbb;
  box-shadow: 0 2px 8px rgba(36, 127, 236, 0.3);
}

.btn-secondary {
  background-color: #ffffff;
  color: #2e3646;
  border: 1px solid #d1d9e2;
}

.btn-secondary:hover {
  background-color: #f8f9fa;
}

.mid-month-note {
  border: 1px solid #e2e8f0;
  background-color: #f4f7fa;
  color: #4a5565;
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mid-month-note p {
  font-size: 14px;
  margin: 0;
}

.header-open {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding: 16px;
  background-color: #f8f9fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-open .title {
  color: #973c00;
  font-size: 14px;
  margin: 0;
  font-weight: 600;
}

.checkbox-form {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #d1d9e2;
  padding: 16px;
  border-radius: 8px;
}

.checkbox-active {
  border-color: #247fec;
  background-color: #ffffff;
}

.checkbox-form input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #247fec;
}

.checkbox-form input[type="checkbox"]:hover {
  accent-color: #247fec;
}

.checkbox-form label {
  font-size: 14px;
  color: #2e3646;
  cursor: pointer;
  user-select: none;
  margin: 0;
}

@media (max-width: 768px) {
  .button-group {
    flex-direction: column;
  }

  .button-group .btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RentAdjustment/FormTabs/Detail/DetailFormStep/EffectiveDate/EffectiveDate.vue